import { Button } from "@/components/ui/button";
import LocaleLink from "@/components/LocaleLink";
import { useTranslation } from "react-i18next";
import { Calendar } from "lucide-react";

/**
 * The four ways out of the homepage, plus the demo ask.
 *
 * It used to sit directly under ProofStrip, third thing on the page, where it
 * competed with the header's own nav a few hundred pixels above it. It now sits
 * on the light shelf inside OneControl, immediately under the pivot line: the
 * reader has just been told cSquare is built for the middle, and this is where
 * they go to check that. Placement is why it is styled for a Brand Ink ground —
 * it takes a lifted Brand Ink ground, solid rather than translucent so the
 * section's contour texture does not read through it, because the band around
 * it is always dark whatever the viewer's theme.
 */
const AnchorNav = () => {
  const { t } = useTranslation();

  const links = [
    { label: t("anchorNav.frameworks"), to: "/framework-library" },
    { label: t("anchorNav.platform"), to: "/features" },
    { label: t("anchorNav.pricing"), to: "/pricing" },
    { label: t("anchorNav.trust"), to: "/trust" },
  ];

  return (
    <nav
      aria-label={t("anchorNav.ariaLabel")}
      className="border-b border-t border-brand-ink-foreground/10 bg-brand-ink-raised"
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between gap-4 py-3 overflow-x-auto">
          <ul className="flex items-center gap-1 sm:gap-2">
            {links.map((link) => (
              <li key={link.label}>
                <LocaleLink
                  to={link.to}
                  className="whitespace-nowrap px-3 py-1.5 text-sm font-medium text-brand-ink-foreground/70 transition-colors hover:bg-brand-ink-foreground/10 hover:text-brand-ink-foreground"
                >
                  {link.label}
                </LocaleLink>
              </li>
            ))}
          </ul>
          <Button asChild size="sm" className="gap-2 shrink-0 hidden sm:inline-flex">
            <LocaleLink to="/book-demo">
              <Calendar className="h-4 w-4" />
              {t("anchorNav.bookDemo")}
            </LocaleLink>
          </Button>
        </div>
      </div>
    </nav>
  );
};

export default AnchorNav;
